import { Component, OnInit } from '@angular/core';
import { CoursesComponent } from '../courses.component';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss'],
    imports: [CoursesComponent]
})
export class ReviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
